'use client'

import React from 'react'
import Link from 'next/link'
import { Star } from 'lucide-react'

interface Props { html: string }

const extractUrl = (html: string): string => {
    const match = html.match(/href=["']([^"']+trustpilot[^"']+)["']/i)
        || html.match(/src=["']([^"']+trustpilot[^"']+)["']/i)
        || html.match(/(https?:\/\/[^\s"'<>]*trustpilot[^\s"'<>]*)/i)
    return match?.[1] || 'https://www.trustpilot.com'
}

const TrustpilotWidget = ({ html }: Props) => {
    const url = extractUrl(html)

    return (
        <Link href={url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-3 py-2 rounded-xl transition-all hover:shadow-md"
            style={{ background: '#ffffff', border: '1px solid #f0ede8', textDecoration: 'none' }}>

            {/* Trustpilot logo */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                <rect width="24" height="24" rx="4" fill="#00B67A" />
                <path d="M12 4.5l2.09 5.76H20l-4.95 3.6 1.89 5.76L12 16.02l-4.94 3.6 1.89-5.76L4 10.26h5.91z" fill="white" />
            </svg>

            <div className="flex flex-col leading-none gap-0.5">
                <span className="text-[10px] font-black uppercase tracking-wider" style={{ color: '#00B67A' }}>
                    Trustpilot
                </span>
                <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, i) => (
                        <Star key={i} size={9} fill="#00B67A" color="#00B67A" />
                    ))}
                </div>
            </div>
        </Link>
    )
}

export default TrustpilotWidget
